import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  Grid,
  Stack,
  Button,
  Divider,
  Container,
  Typography,
  CircularProgress,
  Alert,
  TextField,
  MenuItem,
} from '@mui/material';
// import LeaveStatus, LeaveType, createLeave gibi fonksiyon ve enumları kendi projenize göre import edin

// Enum örnekleri (kendi enumlarınızı kullanın)
const LeaveStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};
const LeaveType = {
  ANNUAL: 'ANNUAL',
  SICK: 'SICK',
  UNPAID: 'UNPAID',
};

export default function PermissionCreate() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState<any>({
    startDate: '',
    endDate: '',
    leaveType: '',
    reason: '',
    status: LeaveStatus.PENDING,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev: any) => ({
      ...prev,
      [event.target.name]: event.target.value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSaving(true);
    try {
      // await createLeave(formData);
      navigate('/dashboard/permissions');
    } catch (err: any) {
      setError('İzin oluşturulurken bir hata oluştu');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>
        <Card sx={{ p: 3 }}>
          <Typography variant="h4" sx={{ mb: 3 }}>
            Yeni İzin Talebi
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
              {error}
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <TextField
                    fullWidth
                    type="date"
                    name="startDate"
                    label="Başlangıç Tarihi"
                    value={formData.startDate || ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    fullWidth
                    type="date"
                    name="endDate"
                    label="Bitiş Tarihi"
                    value={formData.endDate || ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    select
                    fullWidth
                    name="leaveType"
                    label="İzin Türü"
                    value={formData.leaveType || ''}
                    onChange={handleChange}
                  >
                    {Object.values(LeaveType).map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    name="reason"
                    label="Açıklama"
                    value={formData.reason || ''}
                    onChange={handleChange}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <TextField
                    select
                    fullWidth
                    name="status"
                    label="Durum"
                    value={formData.status || ''}
                    onChange={handleChange}
                  >
                    {Object.values(LeaveStatus).map((status) => (
                      <MenuItem key={status} value={status}>
                        {status}
                      </MenuItem>
                    ))}
                  </TextField>
                </Stack>
              </Grid>
            </Grid>
            <Divider sx={{ my: 3 }} />
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                disabled={saving}
              >
                {saving ? 'Kaydediliyor...' : 'Kaydet'}
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate('/dashboard/permissions')}
                disabled={saving}
              >
                İptal
              </Button>
            </Stack>
          </form>
        </Card>
      </Container>
  );
} 